import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TitleBreadbreadcrumbRoutingModule } from './title-breadbreadcrumb-routing.module';
import { TitleBreadbreadcrumbComponent } from './title-breadbreadcrumb.component';
import { MdbGlobalModule } from '../mdb-global.module';


@NgModule({
  declarations: [
    TitleBreadbreadcrumbComponent
  ],
  imports: [
    CommonModule,
    TitleBreadbreadcrumbRoutingModule,
    MdbGlobalModule,
  ],
  exports: [
    TitleBreadbreadcrumbComponent
  ]
})
export class TitleBreadbreadcrumbModule { }
